import React from 'react';
import { Modal, Input, Form, Select, Table, Empty, Tabs, Button } from 'antd';

const { Option } = Select;
const { TabPane } = Tabs;
class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        debugger
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    idConfiguracion: 0,
                    idUsuario: values.idUsuario.key,
                    valor: true,
                    jsonMultiple: JSON.stringify(this.props.formValues.listaDetalle),
                    jsonPermiso: this.fetchPermiso(values),
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }


    fetchPermiso = (values) => {
        var item = [];
        values.idSerieCobranza.forEach((key, i) => {
            item.push({
                idUsuario: values.idUsuario.key,
                serie: key,
                idAlmacen: 0,
                idEstablecimiento: 0,
                idTipoPermiso: 1
            })
        });
        values.idAlmacenLogisticas.forEach((key, i) => {
            item.push({
                idUsuario: values.idUsuario.key,
                serie: null,
                idAlmacen: key,
                idEstablecimiento: 0,
                idTipoPermiso: 2
            })
        });

        values.idAlmacenVentas.forEach((key, i) => {
            item.push({
                idUsuario: values.idUsuario.key,
                serie: null,
                idAlmacen: key,
                idEstablecimiento: 0,
                idTipoPermiso: 3
            })
        });
        return JSON.stringify(item);
    };


    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Configuración Usuario" : "Configuración Usuario"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="800px"
            >
                <Form>
                    <div className="row">

                        <div className="col-md-12 form-group">
                            <Form.Item label="Usuario">
                                {getFieldDecorator('idUsuario', {
                                    initialValue: this.props.formValues.idUsuario > 0 ?
                                        { key: this.props.formValues.idUsuario } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione usuario"}
                                        optionFilterProp="children"
                                        onChange={(value) => this.props.onChangeForm(value, this.props.form)}
                                    >
                                        {this.props.formValues.empleados.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Almacenes disponibles en ventas">
                                {getFieldDecorator('idAlmacenVentas', {
                                    initialValue: this.props.formValues.idAlmacenVentas,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select mode="multiple"
                                        placeholder={"Seleccione almacén"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.almacenVentas.map(item => (
                                            <Option key={item.id} value={item.id} >{item.establecimiento} -{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-12 form-group">
                            <Form.Item label="Almacenes disponibles en logística">
                                {getFieldDecorator('idAlmacenLogisticas', {
                                    initialValue: this.props.formValues.idAlmacenLogisticas,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select mode="multiple"
                                        placeholder={"Seleccione almacén"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.almacenLogisticas.map(item => (
                                            <Option key={item.id} value={item.id} >{item.establecimiento} -{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-12 form-group">
                            <Form.Item label="Serie de comprobantes disponibles para cobranza">
                                {getFieldDecorator('idSerieCobranza', {
                                    initialValue: this.props.formValues.idSerieCobranza,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select
                                        mode="multiple"
                                        placeholder={"Seleccione Serie  para cobranza"}
                                        optionFilterProp="children"                                    >
                                        {this.props.formValues.serieCobranza.map(item => (
                                            <Option key={item.id} value={item.serie} >{item.serie}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-12 form-group">
                            <Tabs
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        <Button
                                            icon="plus"
                                            type="primary"
                                            hidden
                                        >
                                            Agregar
                                        </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Opciones" key="1">
                                    <Table
                                        className={'table-referencia'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={true}
                                        dataSource={this.props.formValues.configuraciones}
                                        rowKey={record => record.id}
                                        rowSelection={{
                                            onChange: this.props.onChangeRow,
                                            selectedRowKeys: this.props.formValues.selectedRowKeys,
                                            hideDefaultSelections: false
                                        }}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='Pulse el botón "+ Agregar".'
                                            />
                                        }}
                                        columns={[

                                            {
                                                title: 'Configuración',
                                                dataIndex: 'nombre',
                                                key: 'nombre',
                                                sorter: true
                                            },
                                            {
                                                title: 'Abreviatura',
                                                dataIndex: 'abreviatura',
                                                key: 'abreviatura',
                                                sorter: true
                                            },
                                            {
                                                title: 'Módulo',
                                                dataIndex: 'modulo',
                                                key: 'modulo',
                                                sorter: true
                                            },
                                        ]}
                                        
                                    />
                                </TabPane>
                            </Tabs>
                        </div>


                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)